/**
 * RTK Query reports a response body it could not parse as `status: 'PARSING_ERROR'`,
 * keeping the HTTP status in `originalStatus`; other string statuses never reached a server.
 */
export const httpStatusOf = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null || !('status' in error)) return undefined;
  if (typeof error.status === 'number') return error.status;

  return 'originalStatus' in error && typeof error.originalStatus === 'number' ? error.originalStatus : undefined;
};
